// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 133) return "static/chunks/133-5c6a112b46f871aa.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "a12126b816cbde15" + ".js";
};